var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check cr-fr",
    clipPath: "url(#clip0_3206_39348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 265"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3206_39348",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6C11.25 4.78538 10.8288 3.60835 10.0583 2.66944C9.28776 1.73053 8.2155 1.08784 7.02422 0.850877C5.83295 0.613918 4.59636 0.797348 3.52517 1.36991C2.45397 1.94248 1.61445 2.86875 1.14963 3.99091C0.684819 5.11307 0.623479 6.36168 0.976063 7.52399C1.32865 8.68631 2.07334 9.69041 3.08326 10.3652C4.09317 11.04 5.30582 11.3438 6.51459 11.2247C7.72336 11.1057 8.85345 10.5712 9.71231 9.71231L9.14116 9.14116C8.41444 9.86789 7.45821 10.3201 6.43542 10.4209C5.41262 10.5216 4.38654 10.2646 3.532 9.69361C2.67747 9.12263 2.04735 8.27301 1.74901 7.28952C1.45067 6.30603 1.50257 5.24953 1.89587 4.30002C2.28918 3.3505 2.99954 2.56674 3.90593 2.08226C4.81232 1.59779 5.85865 1.44258 6.86664 1.64308C7.87464 1.84359 8.78193 2.3874 9.43392 3.18185C10.0859 3.97631 10.4423 4.97226 10.4423 6H11.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6C11.25 4.78538 10.8288 3.60835 10.0583 2.66944C9.28776 1.73053 8.2155 1.08784 7.02422 0.850877C5.83295 0.613918 4.59636 0.797348 3.52517 1.36991C2.45397 1.94248 1.61445 2.86875 1.14963 3.99091C0.684819 5.11307 0.623479 6.36168 0.976063 7.52399C1.32865 8.68631 2.07334 9.69041 3.08326 10.3652C4.09317 11.04 5.30582 11.3438 6.51459 11.2247C7.72336 11.1057 8.85345 10.5712 9.71231 9.71231L9.14116 9.14116C8.41444 9.86789 7.45821 10.3201 6.43542 10.4209C5.41262 10.5216 4.38654 10.2646 3.532 9.69361C2.67747 9.12263 2.04735 8.27301 1.74901 7.28952C1.45067 6.30603 1.50257 5.24953 1.89587 4.30002C2.28918 3.3505 2.99954 2.56674 3.90593 2.08226C4.81232 1.59779 5.85865 1.44258 6.86664 1.64308C7.87464 1.84359 8.78193 2.3874 9.43392 3.18185C10.0859 3.97631 10.4423 4.97226 10.4423 6H11.25Z",
    stroke: "#3F8CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 4 6 8",
    mask: "url(#path-1-inside-1_3206_39348)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3206_39348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.14ad6c3e52b266c69978a2b76eae23f0.svg";
export { ForwardRef as ReactComponent };